{
  "headings": {
    "preview": "Förhandsgranskning av felanmälan",
    "defectNotice": "Gör en felanmälan",
    "defectNoticeEdit": "Redigera felanmälan",
    "success": "Felanmälan",
    "editNotice": "Felanmälan"
  },
  "texts": {
    "instructions": "Anmäl ett icke-brådskande fel i din bostad eller i de allmänna lokalerna. I brådskande ärenden, till exempel vid vattenskador, ska du ringa fastighetsskötselbolaget.",
    "list": {
      "title": "Din felanmälan",
      "workOrder": "Beställning kopplad till felanmälan",
      "status": {
        "completed": "Markerad som behandlad",
        "created": "Skapad"
      }
    },
    "eventsTitle": "Följ framstegen",
    "notEditable": "Den här anmälan kan inte längre redigeras.",
    "notTrackable": "Anmälan har flyttats till ett annat objekt. Den kan inte längre redigeras och dess framsteg kan inte följas."
  },
  "placeholders": {
    "title": "Rubrik",
    "description": "Beskriv problemet närmare",
    "defectClass": "Välj en annan typ av fel"
  },
  "alt": {
    "successIllustration": "Tack illustration"
  },
  "labels": {
    "defectLocation": "Felobjekt",
    "defectClass": "Feltyp",
    "title": "Rubrik",
    "description": "Beskrivning",
    "files": "Bilagor",
    "masterKeyAccessAllowed": "Huvudnyckeln får användas för att komma in i bostaden",
    "hasPetsInApartment": "Husdjur i bostad"
  },
  "actions": {
    "back": "Tillbaka",
    "resetForm": "Töm blanketten",
    "sendForm": "Skicka en felanmälan"
  },
  "defectLocations": {
    "contractTarget": "Bostad {{target}}",
    "commonArea": "Gemensamma utrymmen"
  },
  "errors": {
    "missingUserPhoneNumber": {
      "title": "En felanmälan kan tyvärr inte göras.",
      "message": "Lägg till ditt telefonnummer i din profil för att fortsätta med felanmälan."
    },
    "submitError": "Ett fel uppstod när felanmälan skulle skickas. Om problemet kvarstår eller om felet är brådskande ska du kontakta kundservicen.",
    "serviceUnavailable": "En felanmälan kan inte göras för tillfället. Var god och försök på nytt senare."
  },
  "events": {
    "created": "Skapad",
    "completed": "Markerad som behandlad",
    "workOrderLinked": "Beställning #{{id}} kopplad",
    "workNoteCreated": "Arbetsanteckning: {{note}}",
    "workOrderCreated": "Arbetsbeställning #{{id}} skapad",
    "workOrderStarted": "Arbetsbeställning #{{id}} påbörjad",
    "workOrderCompleted": "Arbetsbeställning #{{id}} markerad som klar",
    "workOrderAccepted": "Arbetsbeställning #{{id}} godkänd"
  },
  "defectClasses": {
    "-1": "Ett annat fel",
    "1": "Reparation",
    "2": "VVS",
    "3": "Mindre reparation",
    "4": "El",
    "5": "Städning",
    "6": "Införskaffningar",
    "7": "Vandalism",
    "8": "Fuktskada",
    "9": "Extra avfall",
    "10": "Extra städning",
    "11": "Låsning",
    "12": "Förhållanden",
    "13": "Brandskada",
    "14": "Byggnadsautomation",
    "15": "Strukturer",
    "16": "Vinterunderhåll",
    "17": "Dataförbindelser",
    "18": "Skadedjur",
    "19": "Vattenskada"
  }
}
